var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3.25,
    fill: "#1C486B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 16.1602V17.424C7.94531 18.1221 8.51117 18.6879 9.2092 18.6879H16.7925C17.4906 18.6879 18.0564 18.1221 18.0564 17.424V16.1602",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83984 11.105L12.9996 7.94531L16.1593 11.105",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 7.94531V15.5286",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/downloadicon.c20e2db5775397eaab9ea84c3edc7b88.svg";
export { ForwardRef as ReactComponent };